"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontCollectionDriver = void 0;
var tslib_1 = require("tslib");
var postcss = tslib_1.__importStar(require("postcss"));
var stylable_collection_1 = require("./stylable-collection");
var stylable_shorthands_1 = require("../stylable-shorthands");
var color_collection_1 = require("./color-collection");
// TOOD: Collect fonts from mixins
var FontCollectionDriver = /** @class */ (function (_super) {
    tslib_1.__extends(FontCollectionDriver, _super);
    function FontCollectionDriver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FontCollectionDriver.prototype.initialData = function () {
        return { colorDeclarations: {}, fontDeclarations: {}, sizeDeclarations: {} };
    };
    FontCollectionDriver.prototype.router = function (decl, sheet, fontData) {
        var addColor = color_collection_1.addColorChangeContext.bind(this, fontData.colorDeclarations, decl);
        var addFontFamily = stylable_collection_1.addChangeContext.bind(this, fontData.fontDeclarations, decl);
        var addFontSize = stylable_collection_1.addChangeContext.bind(this, fontData.sizeDeclarations, decl);
        switch (decl.prop) {
            case 'color':
                this.handleDirectColorProperty(sheet, decl.value, addColor);
                break;
            case 'font':
                this.handleFontShorthandProperty(sheet, decl, addFontFamily, addFontSize);
                break;
            case 'font-family':
                this.handleFontFamilyProperty(sheet, decl.value, addFontFamily);
                break;
            case 'font-size':
                this.handleFontSizeProperty(sheet, decl.value, addFontSize);
                break;
        }
    };
    FontCollectionDriver.prototype.handleDirectColorProperty = function (sheet, declValue, adder) {
        var updateFromAST = this.updateFromAST.bind(this);
        function changeDirectColor(value) {
            this.declaration.value = color_collection_1.preserveAlpha(sheet, value, this.declaration.value);
            updateFromAST(this.declaration);
        }
        adder(sheet.evalDeclarationValue(declValue), changeDirectColor);
    };
    FontCollectionDriver.prototype.handleFontShorthandProperty = function (sheet, decl, familyAdder, sizeAdder) {
        var updateFromAST = this.updateFromAST.bind(this);
        var shorthands = new stylable_shorthands_1.StylableShorthands(sheet.evalDeclarationValue.bind(sheet));
        var expandedDeclaration = shorthands.shallowExpandDeclaration(decl);
        function familyChange(value) {
            var currValue = shorthands.shallowExpandDeclaration(this.declaration)['font-family'];
            this.declaration.value = sheet.evalDeclarationValue(this.declaration.value).replace(currValue, value);
            updateFromAST(this.declaration);
        }
        function sizeChange(value) {
            var currValue = shorthands.shallowExpandDeclaration(this.declaration)['font-size'];
            var newValue = sheet.evalDeclarationValue(this.declaration.value).replace(currValue, value);
            var expandedNewSizeValue = shorthands.shallowExpandDeclaration(postcss.decl({ prop: this.declaration.prop, value: newValue }))['font-size'];
            if (expandedNewSizeValue) {
                this.declaration.value = newValue;
                updateFromAST(this.declaration);
            }
        }
        var familyValue = expandedDeclaration['font-family'].replace(/"/g, '');
        var sizeValue = expandedDeclaration['font-size'];
        familyValue && familyAdder(familyValue, familyChange);
        sizeValue && sizeAdder(sizeValue, sizeChange);
    };
    FontCollectionDriver.prototype.handleFontFamilyProperty = function (sheet, declValue, adder) {
        var updateFromAST = this.updateFromAST.bind(this);
        function changeFontFamily(value) {
            this.declaration.value = value;
            updateFromAST(this.declaration);
        }
        adder(sheet.evalDeclarationValue(declValue), changeFontFamily);
    };
    FontCollectionDriver.prototype.handleFontSizeProperty = function (sheet, declValue, adder) {
        var updateFromAST = this.updateFromAST.bind(this);
        function changeFontSize(value) {
            this.declaration.value = value;
            updateFromAST(this.declaration);
        }
        adder(sheet.evalDeclarationValue(declValue), changeFontSize);
    };
    return FontCollectionDriver;
}(stylable_collection_1.CollectionDriver));
exports.FontCollectionDriver = FontCollectionDriver;
//# sourceMappingURL=font-collection.js.map